import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useConfirmSubtitlesResourceMutation = createMutationHook(
  MembershipsCreatorApiClient.confirmSubtitlesResource,
  {
    mutationKey: ['confirmSubtitlesResource'],
  },
)
